import { Stack, Skeleton, Group, Paper } from '@mantine/core';

/**
 * Loading skeleton component for table view
 * Provides better perceived performance while data is loading
 */
export function TableLoadingSkeleton() {
  return (
    <Paper shadow="sm" p="md" radius="md" withBorder>
      <Stack gap="md">
        {/* Search and export buttons skeleton */}
        <Group justify="space-between" wrap="wrap">
          <Skeleton height={36} width={300} radius="md" />
          <Skeleton height={36} width={150} radius="md" />
        </Group>

        {/* Table header skeleton */}
        <Skeleton height={50} radius="md" />

        {/* Table rows skeleton */}
        {Array.from({ length: 5 }).map((_, index) => (
          <Skeleton key={index} height={60} radius="sm" />
        ))}

        {/* Pagination skeleton */}
        <Group justify="center" mt="md">
          <Skeleton height={32} width={200} radius="md" />
        </Group>
      </Stack>
    </Paper>
  );
}

/**
 * Loading skeleton for inline content
 */
export function InlineLoadingSkeleton({ width = '100%' }: { width?: string | number }) {
  return <Skeleton height={36} width={width} radius="sm" />;
}
